import React from 'react';
import { Box } from '@mui/material';
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import type { SxProps, Theme } from '@mui/material/styles';

interface Props {
  size?: number;
  bgColor?: string;
  iconColor?: string;
  sx?: SxProps<Theme>;
}

const EventRepeatIcon = ({
  size = 48,
  bgColor = '#F2F2F2',
  iconColor = '#303030',
  sx,
}: Props) => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: bgColor,
        color: iconColor,
        display: 'inline-flex',
        height: size,
        justifyContent: 'center',
        width: size,
        ...sx,
      }}
    >
      <EventRepeatOutlinedIcon sx={{ fontSize: Math.round(size * 0.5) }} />
    </Box>
  );
};

export default EventRepeatIcon;
